export default class WS {
    
    constructor(caller, url, protos) {
        
        let protocols = protos || [];
        
        let wsConnection;
       
        wsConnection = new WebSocket(url, protocols);
       
        
        wsConnection.binaryType = 'arraybuffer';
        
        wsConnection.addEventListener('open', (e) => {
            caller.onOpen(e);
        });
        
        wsConnection.addEventListener('message', (e) => {
            caller.onMessage(e);
        });
        
        wsConnection.addEventListener('onclose', (e) => {
            console.log("wsConnection.onclose");
        });
        
        wsConnection.addEventListener('onerror', (e) => {
            console.log("wsConnection.onerror: "+JSON.stringify(e));
        });
        
        
        return wsConnection;
    }
    
}


// WEBPACK FOOTER //
// ./src/WebRTC/WS.js